import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {Company} from '../restaurant-manager.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private apiService: ApiService) {}

  search(searchedCompany: string): Observable<Company[]> {
    return this.apiService.get<Company[]>('/companies/search?q=' + searchedCompany, true).pipe(map((companies: Company[]) => {
      return companies.map(c => new Company(c));
    }));
  }

  get(companyId: string): Observable<Company> {
    return this.apiService.get<Company>('/companies/' + companyId, true).pipe(map((company: Company) => {
      return new Company(company);
    }));
  }

}
